var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{staticClass:"opt",attrs:{"src":_vm.opt ? _vm.ispic : _vm.nopic}})])}
var staticRenderFns = []

export { render, staticRenderFns }